<template>
  <el-menu-item v-if="onlyOneChild.meta" :index="onlyOneChild.name" :class="{'submenu-title-noDropdown':!isNest}">
    <app-link :to="onlyOneChild.redirect||'/index'" style="width:100%;height: 100%;display: inline-block;padding: 0 1.25rem;">
      <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
    </app-link>
  </el-menu-item>
</template>

<script>
import path from 'path'
import { isExternal } from '../../../../../src/utils/validate'
import Item from './Item'
import AppLink from '../../../components/Link'
import FixiOSBug from '../../../components/FixiOSBug'

export default {
  name: 'MenuItemItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    onlyOneChild: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
